var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:{ 'is-matched': _vm.matched }},[(_vm.icon)?_c('div',{staticClass:"item-icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }